// extracted by mini-css-extract-plugin
module.exports = {"modal":"common_modal__PuBB_","inner-container":"common_inner-container__SkNrK","dialog-content":"common_dialog-content__d3eKN"};